import styled from 'styled-components';
import { Card, Link, TextField } from '@material-ui/core';

export const Paragraph = styled.p`
  color: #617799;
  font-family: 'TTCommons';
  font-size: 17px;
  letter-spacing: 0;
  line-height: 21px;
  margin: 8px 0px 40px 0px;
`;

export const CardWrapper = styled(Card)`
  margin-bottom: 20px;
`;

export const StyledLink = styled(Link)`
  color: #6e84a3;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 20px;
`;

export const SpanWrapper = styled.p`
  margin: 28px 0px 0px 0px;
  text-align: center;
`;

export const TextTitle = styled.p`
  color: #12253f;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  font-family: 'TTCommons';
  margin-bottom: 30px;
`;

export const TextWrapper = styled(TextField)`
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 5px 5px rgba(60, 128, 209, 0.09);
  margin-bottom: 15px;
`;

export const TextLabel = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 23px;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const Header = styled.div`
  padding: 3% 0 1% 10%;
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
